// extracted by mini-css-extract-plugin
export default {"paginationNextPreviousLink":"styles_paginationNextPreviousLink__qa-rN","paginationLink":"styles_paginationLink__1knG6","paginationLinkActive":"styles_paginationLinkActive__k4XQm"};